import { Fragment } from 'react';
import type { RescueDocumentType } from '../../lib/documentQueries';
import styles from './Documents.module.scss';

const OPTIONS: { type: RescueDocumentType; link: string }[] = [
  { type: 'STATE_EXEMPTION', link: 'certificate' },
  { type: 'STATE_EXEMPTION_APPLICATION', link: 'application' },
  { type: 'STATE_EXEMPTION_INELIGIBLE', link: 'ineligibility notice' },
];

/**
 * Switches a conditional state's upload between the certificate, proof of application and proof of
 * denial. The certificate is the default, so the other two are offered as alternatives.
 */
export default function DocumentKindPicker({
  accepted,
  value,
  onChange,
}: {
  accepted: RescueDocumentType[];
  value: RescueDocumentType;
  onChange: (type: RescueDocumentType) => void;
}) {
  const others = OPTIONS.filter((option) => accepted.includes(option.type) && option.type !== value);
  const links = (tail: string) =>
    others.map((option, index) => {
      const button = (
        <button type="button" className={styles.kindLink} onClick={() => onChange(option.type)}>
          {option.link}
        </button>
      );
      return (
        <Fragment key={option.type}>
          {index > 0 && ' or '}
          {/* Keeps the closing period from wrapping onto a line of its own. */}
          {index === others.length - 1 ? (
            <span className={styles.kindTail}>
              {button}
              {tail}
            </span>
          ) : (
            button
          )}
        </Fragment>
      );
    });

  if (value === 'STATE_EXEMPTION') {
    return <>Don't have a certificate? Upload your {links('')} instead.</>;
  }
  return <>Uploading something else? Switch to your {links('.')}</>;
}
